<template>
  <BasePopup :model-value="props.isOpen" @update:model-value="$emit('update:isOpen', $event)" custom-class="confirm-popup" :modal-class="data.modalClass" :show-close-button="false" :close-on-overlay="false">
    <div class="confirm-content">
      <h3 v-if="data.title" class="confirm-title">{{ data.title }}</h3>
      <p v-html="data.message"></p>
      <div class="confirm-buttons">
        <button type="button" v-if="showEtcButton" @click="handleEtc" class="btn btn-gray">{{ data.etcText || '' }}</button>
        <button type="button" v-if="showCancelButton" @click="handleCancel" class="btn btn-outline">{{ data.cancelText || '취소' }}</button>
        <button type="button" v-if="showConfirmButton" @click="handleConfirm" class="btn">{{ data.confirmText || '확인' }}</button>
      </div>
      <button type="button" @click="handleCancel" class="btn-cancel"></button>
    </div>
  </BasePopup>
</template>
<script lang="ts" setup>
import BasePopup from '@/components/com/HconComBasePopup.vue'
import type { ConfirmData } from '@/composables/hconUsePopup'

const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true
  },
  showEtcButton: {
    type: Boolean,
    default: true
  },
  showCancelButton: {
    type: Boolean,
    default: true
  },
  showConfirmButton: {
    type: Boolean,
    default: true
  },
  data: {
    type: Object as PropType<ConfirmData>,
    required: true,
    default: () => ({
      modalClass: '',
      title: '',
      message: '',
      confirmText: '확인',
      etcText: '',
      cancelText: '취소',
    })
  }
})

const emit = defineEmits(['confirm', 'cancel', 'etc', 'update:isOpen'])

const handleConfirm = () => {
  emit('confirm')
  emit('update:isOpen', false)
}

const handleCancel = () => {
  emit('cancel')
  emit('update:isOpen', false)
}

const handleEtc = () => {
  emit('etc')
  emit('update:isOpen', false)
}
</script>
<style lang="">
  
</style>